import { render, staticRenderFns } from "./InvitingPatients.vue?vue&type=template&id=d9f27cd4&scoped=true"
import script from "./InvitingPatients.vue?vue&type=script&lang=js"
export * from "./InvitingPatients.vue?vue&type=script&lang=js"
import style0 from "./InvitingPatients.vue?vue&type=style&index=0&id=d9f27cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f27cd4",
  null
  
)

export default component.exports